import { sourceHasValidMedia } from "~components/shared/media/";
import type { VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

import { SECONDARY_ITEM_MEDIA_PRIORITY } from "./LineupContentOpinion2UpVerticalXs";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    if (!items?.length || items.length < 2) {
        return [
            "The LineupContentOpinion2UpVerticalXs module requires at least two stories.",
        ];
    }

    // has vertical video in left/first element
    const isFirstItemVerticalVideo = items[0]?.media?.verticalVideo;

    if (!isFirstItemVerticalVideo) {
        // Left content should always be vertical video
        return ["First Story: Only vertical video is allowed in first story"];
    }

    // has vertical video in right element
    const isSecondItemVerticalVideo = items[1]?.media?.verticalVideo;

    if (isSecondItemVerticalVideo) {
        // vertical video is only allowed as left content
        return [
            "Second Story: Vertical video is allowed in the first story only",
        ];
    }

    const filteredItems = items.filter((item) =>
        sourceHasValidMedia(item, SECONDARY_ITEM_MEDIA_PRIORITY)
    );

    // checking is less than 1 instead of 2, because the first item should always have a vertical video
    if (filteredItems.length < 1) {
        return [
            `This LineupContentOpinion2UpVerticalXs requires at least two stories WITH valid media. (${SECONDARY_ITEM_MEDIA_PRIORITY})`,
        ];
    }

    return checkItemArrayIntegrity(filteredItems, ["headline"]);
}
